import DepartmentsDataStore from "../pages/DepartmentsDataStore";

const departmentDataStore: DepartmentsDataStore = new DepartmentsDataStore();

export function getDepartmentDataStore() {
  return departmentDataStore;
}